import React from "react";
import { Helmet } from "react-helmet";

const getHelmetContent = () => {
  return {
    meta: [
      { name: "keywords", content: "AI automation solutions, business automation, workflow automation, AI agents, AI agent development, enterprise AI solutions, AI-powered automation, intelligent automation, process automation, business process automation, custom AI solutions, AI software company, AI automation company in Pune, AI automation company in India, AI consulting services, AI implementation company, generative AI solutions, AI chatbot development, AI workflow automation, document automation, AI operations automation, AI for enterprises, AI digital transformation, AI productivity solutions, AI integration services, AI automation platform, AI services company Pune, AI software development company India, AI-driven workflow automation, secure AI deployment, private AI solutions, AI transformation company, automation consulting services, AI technology consulting,  AI for law firms, legal AI solutions, AI legal drafting, AI legal research, legal document automation, AI legal assistant, AI for advocates, AI for lawyers, AI contract drafting, AI case summary generation, AI judgment analysis, legal workflow automation, legal document search AI, AI legal chatbot, AI case management, AI for legal operations, secure AI for law firms, private AI for legal firms, Marathi legal drafting AI, AI-powered legal drafting, AI-based legal research, AI legal document generator, AI for court case analysis, AI legal automation company, law firm automation company in Pune, legal AI company India, legal process automation, AI for litigation support, AI for legal document review, AI for advocates in India ,AI for manufacturing, manufacturing AI solutions, smart manufacturing AI, factory automation AI, industrial AI solutions, predictive maintenance AI, AI quality inspection, AI production planning, AI inventory forecasting, AI warehouse optimization, AI procurement automation, AI demand forecasting, computer vision for manufacturing, AI for factories, AI for production management, AI-driven manufacturing operations, AI maintenance scheduling, AI condition monitoring, smart factory solutions, AI for industrial automation, AI-powered manufacturing analytics, manufacturing workflow automation, AI for supply chain management, AI production optimization, AI for machine monitoring, AI plant operations, manufacturing automation company Pune, industrial automation AI India, AI quality control systems, AI for hospitals, healthcare AI solutions, hospital AI automation, healthcare workflow automation, AI hospital dashboard, AI patient summaries, AI clinical summaries, patient flow automation, AI diagnostics support, healthcare analytics platform, AI for healthcare industry, hospital workflow automation, AI hospital management support, AI for hospital operations, AI medical report analysis, AI healthcare chatbot, AI patient communication system, hospital billing automation, healthcare process automation, AI healthcare analytics, AI patient monitoring, AI-powered healthcare operations, AI for OPD management, AI healthcare automation company, healthcare AI company Pune, hospital automation solutions India, AI for ICU monitoring, AI healthcare data analysis, AI for medical operations, AI hospital intelligence platform "},
      { name: "description", content: "ThinkQuotient provides AI automation, workflow automation, AI agents, and data automation solutions to help businesses reduce manual work, improve accuracy, and scale operations across legal, healthcare, manufacturing, real estate, EdTech, and enterprise sectors." } ,     
      { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      { name: "language", content: "English" },
    ],

    script: [
      <script type="application/ld+json">
        {`
            {
              "@context": "http://www.schema.org",
              "@type": "ProfessionalService",
              "name": " Professional Training Institute in Pune",
              "url": "https://www.thinkquotient.ai/",
              "logo": "https://www.thinkquotient.ai/assets/images/envelop.png",
              "image": "https://thinkquotient.ai/assets/images/envelop.png",
              "description": "ThinkQuotient specializes in IT development and as well as in freshers training.",
              "telephone": "+917030055128",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": " 2nd Floor, Nirmitee Elite, 103, Law College Rd, next to Starbucks, Shanti Sheela Society, Apex Colony, Erandwane, Pune",
                "addressLocality": "Pune",
                "addressRegion": "Maharashtra",
                "postalCode": "411004",
                "addressCountry": "India"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": "18.51455",
                "longitude": "73.82876"
              },
              "sameAs": [
                "https://www.facebook.com/profile.php?id=61589595790421/",
                "https://twitter.com/ThinkQuotient",
                "https://www.linkedin.com/company/thinkquotient/",
                "https://www.instagram.com/thinkquotient_software/?igshid=1j31daue8ovci"
              ]
            }
          `}
      </script>,

      // Updated Google Tag Manager script
      <script>
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KTNBVH9V');
        `}
      </script>,

      // Google Analytics tracking scripts
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-143016865-1"></script>,
      <script>
        {`
          window.dataLayer = window.dataLayer || []; 
          function gtag() { dataLayer.push(arguments); } 
          gtag('js', new Date()); 
          gtag('config', 'UA-143016865-1');
        `}
      </script>,

      <script async src="https://www.googletagmanager.com/gtag/js?id=G-BSFPPN5E9D"></script>,
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', 'G-BSFPPN5E9D');
        `}
      </script>,

      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-574047969"></script>,
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', 'AW-574047969');
        `}
      </script>,
    ],

    noscript: [
      // Google Tag Manager noscript fallback
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-KTNBVH9V"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>,
    ],
  };
};

export default getHelmetContent;
